import React, { useEffect } from "react";
import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";

export default function PdfViewer({ url, onLoad, loading,Name}) {
  pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

  const renderPDF = (url, canvasContainer, options) => {
    console.log("renderPDF",url)
    options = options || { scale: 1 };
    var outputScale = window.devicePixelRatio || 1;
    const renderPage = (page) => {
      const viewport = page.getViewport({ scale: 1.0 });
      var wrapper = document.createElement("div");
      wrapper.className = "canvas-wrapper";
      var canvas = document.createElement("canvas");
      // canvas.height = "540";
      // canvas.width = "960";
      // canvas.height = "600";
      canvas.width = Math.floor(viewport.width * outputScale);
      canvas.height = Math.floor(viewport.height * outputScale);

      let modalWidth = document.getElementById("vdi-modal-body");
      if (window.innerWidth < 992) {
        canvas.style.width = modalWidth - 100 + "px";
        canvas.style.height = modalWidth - 200 + "px";
      } else {
        canvas.style.width = Math.floor(viewport.width) - 60 + "px";
        canvas.style.height = Math.floor(viewport.height) + "px";
      }

      var transform =
        outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null;
      var ctx = canvas.getContext("2d");
      var renderContext = {
        canvasContext: ctx,
        transform: transform,
        viewport: viewport,
      };

      wrapper.appendChild(canvas);
      canvasContainer.appendChild(wrapper);

      page.render(renderContext);
    };

    const renderPages = async (pdfDoc) => {
      if (!document.getElementById(Name).innerHTML) {
        for (var num = 1; num <= pdfDoc.numPages; num++) {
          await pdfDoc.getPage(num).then(renderPage);
        }
      }
      onLoad();
    };

    pdfjsLib.disableWorker = true;
    const loadingTask = pdfjsLib.getDocument(url);
    loadingTask.promise.then(
      (loadedPdf) => {
        renderPages(loadedPdf);
      },
      function (reason) {
        console.error(reason);
      }
    );
  };

  useEffect(() => {
    renderPDF(url, document.getElementById(Name));
  }, []);

  return (
    <>
      <div
        style={{
          ...(loading
            ? {
                display: "none",
              }
            : { display: "block" }),
        }}
        id={Name}
      ></div>
    </>
  );
}
